import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";

// Material
import { Grid, useTheme, useMediaQuery, Slide, Box } from "@material-ui/core";

// components
import StudentSearch from "./studentSearch";
import DataTabs from "./dataTabs";

// props
import getDashboardProps from "@/props-constants/dashboard-props";

// actions
import { universityDetailsGetAndStore } from "@/store/actions/universityDetailsActions";
import { setIsLoading } from "@/store/actions/commonActions";
import { goToRoute } from "@/store/actions/navigationActions";

// utils
import routePaths from "@/utils/route-paths";
import { checkAndGetCredentialsFromSession, storeCredentialsInSession } from "@/utils/session";
let timeout = null;

export default function Dashboard() {
    const dispatch = useDispatch();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const universityDetails = useSelector((state) => state.universityDetails.data);
    const commonActions = useSelector((state) => state.common);

    const dashboardProps = getDashboardProps(universityDetails.universityName, universityDetails.eventDate);
    // this use effect checks if the credentials are in session storage. If not redirects to login page
    const search = new URLSearchParams(useSelector((state) => state.router.location.search));
    const searchParams = Object.fromEntries(search);
    useEffect(() => {
        if (isEmpty(universityDetails)) {
            dispatch(setIsLoading(true));
            const { university_code, fair_id, student_id } = searchParams;
            if (university_code && fair_id && student_id) {
                const payload = {
                    university_code,
                    fair_id,
                };
                if (!timeout)
                    timeout = setTimeout(() => {
                        dispatch(
                            universityDetailsGetAndStore(payload, (data) => {
                                storeCredentialsInSession(
                                    data.university_code,
                                    data.fair_id,
                                    data.access_token
                                );
                                dispatch(setIsLoading(false));
                            })
                        );
                    }, 100);
                else {
                    dispatch(goToRoute(routePaths.NOT_AUTHORIZED));
                    dispatch(setIsLoading(false));
                }
            } else {
                const sessionCreds = checkAndGetCredentialsFromSession();
                if (sessionCreds) {
                    const payload = {
                        university_code: sessionCreds.universityCode,
                        fair_id: sessionCreds.fairID,
                    };
                    dispatch(
                        universityDetailsGetAndStore(payload, (data) => {
                            storeCredentialsInSession(data.university_code, data.fair_id, data.access_token);
                            dispatch(setIsLoading(false));
                        })
                    );
                } else {
                    dispatch(setIsLoading(false));
                    dispatch(goToRoute(routePaths.UNIVERSITY_LOGIN));
                }
            }
        }
    }, []);

    if (isMobile) {
        return (
            <Grid container>
                <StudentSearch
                    studentId={searchParams.student_id}
                    studentSearchProps={dashboardProps.studentSearchProps}
                />
                <Slide
                    timeout={300}
                    direction="left"
                    in={commonActions.showStudentDetailsInMobile}
                    mountOnEnter
                    unmountOnExit
                >
                    <Box mt={9} width={"100%"}>
                        <DataTabs isMobile={isMobile} />
                    </Box>
                </Slide>
            </Grid>
        );
    }
    return (
        <Grid container>
            <StudentSearch
                studentId={searchParams.student_id}
                studentSearchProps={dashboardProps.studentSearchProps}
            />
            <DataTabs isMobile={isMobile} />
        </Grid>
    );
}
